import SupremeGolfApiClient from './SupremeGolfApiClient';

const MARKETING_ENDPOINT = 'v6/marketing/';

const GENERATE_ITERABLE_JWT = 'iterable/jwt_tokens';

export default class MarketingApi {
  static async generateIterableJwt() {
    const response = await SupremeGolfApiClient.get(`${MARKETING_ENDPOINT}${GENERATE_ITERABLE_JWT}`);

    return response.data;
  }
}
